import { TariffManagementAdvancedSearch } from "../TariffManagementAdvancedSearch";
import { Button, DataSource, Label, Layout, LayoutHeader, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutGeneralRateIncrease extends Layout {
    buttonClearForm: Button;
    buttonFilterTLIs: Button;
    labelCustomersAffected: Label;
    labelTariffDetails: Label;
    layoutTLIAdvancedSearch: TariffManagementAdvancedSearch;
    layoutheaderTitle: LayoutHeader;
    panelButtons: Panel;
    panelGRIControls: Panel;
    panelSpacer1: Panel;
    panelSpacer2: Panel;
    panelSpacer4: Panel;
    panelTariffLineItemTableAdjusted: Panel;
    sourceCustomer: DataSource;
    sourceTariffLineItem: DataSource;
    tabSearchTLIs: Tab;
    tableAffectedCustomers: Table;
    tableTariffLineItem: Table;
    tabsetSearch: Tabset;
    textboxCustomerId: Textbox;
    textboxEffectiveDate: Textbox;
    textboxTariffID: Textbox;
    textboxType: Textbox;
}
